import { useMutation } from '@tanstack/react-query';
import { toast } from '@huspy/forge/shared';
import queryClient from '@app/queryClient';
import { opportunitiesApi } from '@modules/opportunities/entities/opportunity/api';
import { t } from 'i18next';
import { trackAmplitudeEvent } from '@shared/analytics/amplitude';
import { USER_EVENTS } from '@shared/analytics/events';

export const useShareVaultViaEmail = (opportunityId: string, clientId?: string) => {
  const {
    error, mutate, isPending, mutateAsync,
  } = useMutation({
    mutationKey: ['shareOpportunityVaultViaEmail'],
    mutationFn: () => {
      trackAmplitudeEvent(
        USER_EVENTS.VAULT.VAULT_SHARE_EMAIL_ATTEMPTED,
        {
          case_id: opportunityId,
          client_id: clientId,
        }
      );
      return opportunitiesApi.shareVaultViaEmail(opportunityId);
    },
    onSuccess: async (data) => {
      await queryClient.refetchQueries({ queryKey: ['vaultConfig', data.opportunity_external_id] });
      trackAmplitudeEvent(
        USER_EVENTS.VAULT.VAULT_SHARE_EMAIL_COMPLETED,
        {
          case_id: opportunityId,
          client_id: clientId,
        }
      );
      toast('info', { message: t('opportunity.mutations.vaultSharingViaEmailSuccess') });
    },
    onError: (_error) => {
      trackAmplitudeEvent(
        USER_EVENTS.VAULT.VAULT_SHARE_EMAIL_FAILED,
        { error: _error }
      );
      toast('error', { message: t('opportunity.mutations.vaultSharingViaEmailFail') });
    },
  });

  return {
    mutate,
    error,
    isPending,
    mutateAsync,
  };
};
